import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { translations } from '../translations';
import '../styles/pages/Gallery.css';

function Gallery({ language }) {
  const t = translations[language];
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const user = localStorage.getItem('userData');
    
    if (token && user) {
      setIsAuthenticated(true);
    } else {
      navigate('/');
    }
    setLoading(false);
  }, [navigate]);

  // Gallery images - add more images here as needed
  const galleryImages = [
    { id: 1, src: require('../assets/gallery/1.jpeg'), title: 'App Preview 1' },
    { id: 2, src: require('../assets/gallery/2.jpeg'), title: 'App Preview 2' },
    { id: 3, src: require('../assets/gallery/3.jpeg'), title: 'App Preview 3' },
    { id: 4, src: require('../assets/gallery/4.jpeg'), title: 'App Preview 4' },
    { id: 5, src: require('../assets/gallery/5.jpeg'), title: 'App Preview 5' },
    { id: 6, src: require('../assets/gallery/6.jpeg'), title: 'App Preview 6' },
    { id: 7, src: require('../assets/gallery/7.jpeg'), title: 'App Preview 7' },
    { id: 8, src: require('../assets/gallery/8.jpeg'), title: 'App Preview 8' },
    { id: 9, src: require('../assets/gallery/9.jpeg'), title: 'App Preview 9' },
    { id: 10, src: require('../assets/gallery/10.jpeg'), title: 'App Preview 10' },
  ];

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const goToPrevious = useCallback(() => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  }, [galleryImages.length]);

  const goToNext = useCallback(() => {
    setCurrentImageIndex((prev) => 
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  }, [galleryImages.length]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!modalOpen) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'ArrowRight') goToNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalOpen, goToPrevious, goToNext]);

  if (loading) {
    return (
      <div className="gallery-page-container">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="gallery-page-container">
      <div className="gallery-header">
        <h2 className="gallery-title">{t.galleryTitle || 'Game Gallery'}</h2>
        <p className="gallery-subtitle">{t.galleryDescription || 'Discover the DysOrto experience'}</p>
      </div>

      <div className="masonry-grid">
        {galleryImages.map((image, index) => (
          <div key={image.id} className="masonry-item">
            <div className="gallery-card">
              <div className="gallery-image">
                {image.src ? (
                  <img src={image.src} alt={image.title} />
                ) : (
                  <div className="placeholder">
                    <span>{image.title}</span>
                  </div>
                )}
              </div>
              <div className="gallery-overlay" onClick={() => openModal(index)}>
                <button className="gallery-button">
                  <span className="zoom-icon">🔍</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Image Modal */}
      {modalOpen && (
        <div className="image-modal-overlay" onClick={closeModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            
            <button className="modal-nav modal-prev" onClick={goToPrevious}>
              ‹
            </button>
            
            <div className="modal-image-container">
              {galleryImages[currentImageIndex].src ? (
                <img 
                  src={galleryImages[currentImageIndex].src} 
                  alt={galleryImages[currentImageIndex].title} 
                />
              ) : (
                <div className="modal-placeholder">
                  <span className="modal-placeholder-icon">🎮</span>
                  <span>{galleryImages[currentImageIndex].title}</span>
                </div>
              )}
            </div>
            
            <button className="modal-nav modal-next" onClick={goToNext}>
              ›
            </button>
            
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
